module.exports = __webpack_public_path__ + "static/media/md-thumbs-down.6a2f8e08.svg";